import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MyLearningService {
  httpUrl = environment.url;
  constructor(private httpClient: HttpClient) { }


  //Programs API
async getPrograms(orgId: any, groupId: any){
  return new Promise((resolve, reject) => {    
    try{
      this.httpClient.get<any>(`${this.httpUrl}/getPrograms.php?orgId=${orgId}&groupId=${groupId}`, {}).subscribe(data => {
        // console.log(data);
        resolve(data)
      });     
      
    }catch(err){
      console.log(err);
      reject(err);
    }
  })
  
  }

    //Pending Achieve Program API
async getAchieveProgramByStatus(status: string){
  return new Promise((resolve, reject) => {    
    try{
      this.httpClient.get<any>(`https://us-central1-achieve-application.cloudfunctions.net/programs-getProgramsUsingStatus?status=${status}`, {}).subscribe(data => {
        // console.log(data);
        resolve(data)
      });     
      
    }catch(err){
      console.log(err);
      reject(err);
    }
  })
  
  }


  //Enrolments API:
  async getCurrentEnrolments(userName:any){
    return new Promise((resolve, reject) => {
      try{
        this.httpClient.get<any>(`${this.httpUrl}/getCurrentEnrolments.php?username=${userName}`).subscribe(data => {
          resolve(data);
        });
        
      }catch(err){
        console.log(err);
        reject(err);
      }
    })
    
  }

  
}
